//@ts-check

/**
 * Renders the "Different invoice address" checkbox that sits on the shipping
 * section in shipping mode. Unchecked = shipping+billing merged, checked = two
 * separate sections.
 */
export class BillingShippingToggleComponent {
  constructor({ checked, onChange }) {
    this.initallyChecked = checked;
    this.onChange = onChange;
  }

  // Appends the checkbox wrapper to the given parent element (shipping section).
  appendTo(parentElement) {
    this.element = document.createElement("div");
    this.element.dataset.mergeToggle = "billing-shipping";
    this.element.innerHTML = `
      <input type="checkbox" id="ui_different_invoice_address">
      <label for="ui_different_invoice_address" data-id="different_shipping_address_toggle">Different Shipping address</label>
    `;
    parentElement.appendChild(this.element);

    this.checkbox = /** @type {HTMLInputElement} */ (
      this.element.querySelector("input")
    );

    this.checked = this.initallyChecked;

    this.addListeners();
  }

  set checked(value) {
    this.checkbox.checked = value;
  }

  setChecked(value) {
    this.checkbox.checked = value;
  }

  get checked() {
    return this.checkbox.checked;
  }

  addListeners() {
    this._handleChange = () => this.onChange(this.checked);
    this.checkbox.addEventListener("change", this._handleChange);
  }

  removeListeners() {
    this.checkbox.removeEventListener("change", this._handleChange);
  }
}
